import { useState } from 'react';
import JoinModal from './JoinModal';
import './JoinNewroCTA.css';

const JoinNewroCTA = ({ variant = 'default' }) => {
    const [isJoinModalOpen, setIsJoinModalOpen] = useState(false);

    return (
        <>
            <section className={`join-newro-cta ${variant === 'compact' ? 'join-newro-cta--compact' : ''}`}>
                <div className="join-newro-cta__container">
                    <div className="join-newro-cta__content">
                      
                        <h2 className="join-newro-cta__title">
                            Be part of the Newro Connect community
                        </h2>
                        <p className="join-newro-cta__description">
                            Share your expertise, connect with clients, and grow your practice alongside fellow movement professionals.
                        </p>
                        <button
                            className="join-newro-cta__button"
                            onClick={() => setIsJoinModalOpen(true)}
                        >
                            <span>Join Newro Connect</span>
                            <ArrowIcon />
                        </button>
                    </div>
                </div>
            </section>
            <JoinModal
                isOpen={isJoinModalOpen}
                onClose={() => setIsJoinModalOpen(false)}
            />
        </>
    );
};

export default JoinNewroCTA;



const ArrowIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 12h14" />
        <path d="m12 5 7 7-7 7" />
    </svg>
);